import { setMeta } from '@/helpers/metaHelpers'

export default {
  watch: {
    $page(to) {
      if (to.seo) setMeta(to.seo)
    },
    'route.name': {
      immediate: true,
      handler() {
        if (this.$page) setMeta(this.$page.seo)
      },
    },
  },
}
